import React, { useEffect, useMemo, useState } from "react";

type Props = {
  spriteUrl: string;      // "/images/animated-arch-sprite.png"
  frameCount: number;     // how many frames across
  frameWidth: number;     // px
  frameHeight: number;    // px
  fps?: number;           // frames per second
  className?: string;
  style?: React.CSSProperties;
};

export default function ArchSprite({
  spriteUrl,
  frameCount,
  frameWidth,
  frameHeight,
  fps = 12,
  className,
  style,
}: Props) {
  const [frameIndex, setFrameIndex] = useState(0);
  const intervalMs = useMemo(() => Math.max(20, Math.floor(1000 / fps)), [fps]);

  useEffect(() => {
    const id = window.setInterval(() => {
      setFrameIndex((prev) => (prev + 1) % frameCount);
    }, intervalMs);

    return () => window.clearInterval(id);
  }, [frameCount, intervalMs]);

  const x = -(frameIndex * frameWidth);

  return (
    <div
      className={`archSpriteWrap ${className ?? ""}`}
      style={
        {
          "--frameW": `${frameWidth}px`,
          "--frameH": `${frameHeight}px`,
          ...style,
        } as React.CSSProperties
      }
      aria-hidden="true"
    >
      <div
        className="archSprite"
        style={{
          backgroundImage: `url(${spriteUrl})`,
          backgroundSize: `${frameCount * frameWidth}px ${frameHeight}px`,
          backgroundPosition: `${x}px 0px`,
        }}
      />
    </div>
  );
}
